<template>
  <div id="app">
    <keep-alive :max="1">
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  created() {
    const state = sessionStorage.getItem("state");
    if (state) {
      this.$store.replaceState(
        Object.assign(this.$store.state, JSON.parse(state))
      );
      sessionStorage.removeItem("state");
    }
  },
  mounted() {
    // 保证页面刷新时store的值不丢失
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("state", JSON.stringify(this.$store.state));
    });
    // 保证点击页面的后退和前进按钮时模块选中效果同时变化
    // window.addEventListener("popstate", e => {
    //   this.$store.commit("setHistory", e.target.location.href);
    // });
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload");
    // window.removeEventListener("popstate");
  },
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100vw;
  height: 100vh;
}
.renameDialog {
  .el-dialog {
    width: 460px !important;
    margin-top: 40vh;
  }
  .el-form-item__content {
    display: inline-block;
  }
  .el-dialog__header {
    text-align: left;
  }
  .el-dialog__body {
    padding: 20px;
    text-align: left;
  }
  .dialog-footer {
    .el-button {
      width: 120px;
    }
  }
  .el-input {
    width: 260px;
  }
  .el-form-item {
    margin-bottom: 0;
  }
}
</style>
